import React, { useState } from "react";
import { Link } from "react-router-dom";
import useCartStore from "../Stores/CartStore"; // تأكد من المسار الصحيح
import logo from "../Assets/logo.jpg";

const Navbar = () => {
  const { items } = useCartStore((state) => ({
    items: state.items,
  }));

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow p-2">
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Logo and Links for larger screens */}
        <div className="flex items-center gap-3">
          <img src={logo} alt="Logo" width={`60px`} />

          {/* Links for larger screens */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/"
              className="text-gray-700 hover:bg-gray-800 hover:text-white transition p-2 rounded"
            >
              الرئيسية
            </Link>
          </div>
        </div>

        {/* Cart Button */}
        <div className="relative">
          <Link
            to="/cart"
            className="text-gray-700 hover:bg-gray-800 hover:text-white p-2 rounded relative transition"
          >
            🛒 سلة التسوق
          </Link>
          {items.length > 0 && (
            <span className="absolute right-0 -top-4 bg-gray-800 text-white text-xs rounded-full px-2 py-1">
              {items.length}
            </span>
          )}
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden text-gray-700 hover:text-gray-900 focus:outline-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "✖️" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="flex flex-col items-center gap-2 py-4">
            <Link
              to="/"
              className="text-gray-700 hover:bg-gray-800 hover:text-white block transition p-2 rounded w-full text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              الصفحة الرئيسية
            </Link>

          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
